import React from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import { Navbar } from "./elements/Navbar";
import Footer from "./elements/Footer";

interface LayoutProps {
  children?: React.ReactNode;
}

const MainLayout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <>
      <Navbar />
      <Main>
        <Container>
          {children}
          <Outlet />
        </Container>
      </Main>
      <Footer />
    </>
  );
};

export default MainLayout;

const Main = styled.main`
  width: 100%;
  min-height: 100vh;
  margin-bottom: 40px;
`;

const Container = styled.div`
  margin: 0 auto;
  margin-top: 30px;
  max-width: 1320px;
`;
